import React, { ChangeEvent, FC } from 'react';
import TransparentButton from '../../../shared/transparent-button/transparent-button';
import AutoTextArea from '../../../shared/auto-textarea/auto-textarea';
import { SHORT_PLAIN_TEXT_LENGTH } from '../../../../constans/common-constants';
import { observer } from 'mobx-react';

interface IProps {
  cancelHandler: () => void;
  onChangeQuestion: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  isDisabled: boolean;
  question: string;
  title: string;
}

const ManagePollHeader: FC<IProps> = (props) => {
  const {
    cancelHandler,
    onSubmit,
    isDisabled,
    onChangeQuestion,
    question,
    title
  } = props;

  return (
    <div className='manage-poll-header'>
      <div className='manage-poll-actions'>
        <h5>{title}</h5>
        <div className='manage-poll-action-buttons'>
          <TransparentButton
            onClick={cancelHandler}
          >
            Cancel
          </TransparentButton>
          <TransparentButton
            customClasses='blue-button'
            onClick={onSubmit}
            disabled={isDisabled}
          >
            Save
          </TransparentButton>
        </div>
      </div>

      <div className='manage-poll-question'>
        <AutoTextArea
          className='manage-poll-question-textarea'
          classNameWrapper='main'
          placeholder='Enter poll question…'
          onChange={onChangeQuestion}
          value={question}
          hasError={question.length > SHORT_PLAIN_TEXT_LENGTH}
        />
      </div>
    </div>
  );
};

export default observer(ManagePollHeader);